import * as Yup from "yup";
import { isValidUrl } from "../../../Utils/stringUtls";
const generalErrorMessage = "Field is required";

export const validationSchemaOnlineCardSales = Yup.object({
  online_card_sales_would_you_like_i2c_c_cart: Yup.string().optional().oneOf(["yes", "no", "na"], "Invalid selection"),
  online_card_sales_i2c_c_card_language: Yup.array().when(
    "online_card_sales_would_you_like_i2c_c_cart",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  online_card_sales_i2c_c_card_language_other: Yup.string().when(
    "online_card_sales_i2c_c_card_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});
export const validationSchemaCardHolderWebsite = Yup.object({
  cardholder_website_would_you_like_cardholder_website: Yup.string()
    .optional(),
  cardholder_website_web_language: Yup.array().when(
    "cardholder_website_would_you_like_cardholder_website",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  cardholder_website_web_language_other: Yup.string().when(
    "cardholder_website_web_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  cardholder_website_url: Yup.string().when(
    "cardholder_website_would_you_like_cardholder_website",
    {
      is: (value) => value === "yes",
      then: () => Yup.string().optional().test('is-valid-url', 'Invalid URL', (value) => !value || isValidUrl(value)),
      otherwise: () => Yup.string().optional(),
    }
  ),
});

export const validationSchemaNativeMobileApplication = Yup.object({
  native_mobile_application_would_you_like_mobile_app: Yup.string()
    .optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  native_mobile_application_native_platform: Yup.array().when(
    "native_mobile_application_would_you_like_mobile_app",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  native_mobile_application_mobile_language: Yup.array().when(
    "native_mobile_application_would_you_like_mobile_app",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  native_mobile_application_mobile_language_other: Yup.string().when(
    "native_mobile_application_mobile_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  native_mobile_application_mobile_app_publishing: Yup.string().when(
    "native_mobile_application_would_you_like_mobile_app",
    {
      is: (value) => value === "yes",
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});

export const validationSchemaIVR = Yup.object({
  ivr_would_you_like_ivr_services: Yup.string().optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  ivr_language: Yup.array().when(
    "ivr_would_you_like_ivr_services",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  ivr_language_other: Yup.string().when(
    "ivr_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  ivr_dialing_you_like_to_use_with_ivr: Yup.array().when(
    "ivr_would_you_like_ivr_services",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  ivr_dialing_you_like_to_use_with_ivr_other: Yup.string().when(
    "ivr_dialing_you_like_to_use_with_ivr",
    {
      is: (options) => options && options.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  ivr_would_you_like_i2c_to_provide_toll_free_number_did: Yup.string().when(
    "ivr_would_you_like_ivr_services",
    {
      is: (value) => value === "yes",
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  ivr_would_you_like_to_resporg_your_toll_free_number_to_i2c: Yup.string().when(
    "ivr_would_you_like_ivr_services",
    {
      is: (value) => value === "yes",
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});
export const validationSchemaContactCenterServices = Yup.object({
  contact_center_service_would_you_like_contact_center_service: Yup.string()
    .optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  contact_center_service_toll_free_number: Yup.string().when(
    "contact_center_service_would_you_like_contact_center_service",
    ([value], schema) => {
      return value === "yes"
        ? schema
            .transform((value) => value || "")
            .test(
              'is-valid-phone',
              'Please enter a valid toll-free number',
              function(value) {
                if (!value || value.trim() === "") return true;
                return /^[0-9\-+()\s]+$/.test(value);
              }
            )
        : schema.optional();
    }
  ),
  contact_center_service_support_language: Yup.array().optional(),
  contact_center_service_support_language_other: Yup.string().when(
    "contact_center_service_support_language",
    ([languages], schema) => {
      return languages && languages.includes("other")
        ? schema.optional()
        : schema.optional();
    }
  ),
  contact_center_service_expected_hours_of_operation_for_customer_service: Yup.string().optional(),
  contact_center_service_expected_hours_of_operation_for_customer_service_custom_hrs: Yup.string().optional(),
  contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow: Yup.string().when(
    "contact_center_service_would_you_like_contact_center_service",
    ([value], schema) => {
      return value === "yes"
        ? schema.optional().oneOf(["yes", "no"], "Invalid selection")
        : schema.optional();
    }
  ),
  contact_center_service_support_hours_required: Yup.number()
    .transform((value, originalValue) => {
      // Transform empty string to undefined
      if (originalValue === '' || originalValue === null) return undefined;
      return value;
    })
    .when(
      "contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow",
      ([value], schema) => {
        return value === "yes"
          ? schema
              .typeError("Please enter a valid number")
              .positive("Hours must be a positive number")
              .integer("Hours must be a whole number")
              .optional()
          : schema.optional();
      }
    ),
});
export const validationSchemaBulkCardOrderingPortal = Yup.object({
  bulk_card_ordering_portal_would_you_like_c_partner: Yup.string()
    .optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  bulk_card_ordering_portal_c_partner_language: Yup.array().when(
    "bulk_card_ordering_portal_would_you_like_c_partner",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  bulk_card_ordering_portal_c_partner_language_other: Yup.string().when(
    "bulk_card_ordering_portal_c_partner_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  bulk_card_ordering_portal_url: Yup.string().when(
    "bulk_card_ordering_portal_would_you_like_c_partner",
    {
      is: (value) => value === "yes",
      then: () => Yup.string()
        .transform((value) => value || "")
        .test(
          'is-valid-url',
          'Please enter a valid URL',
          function(value) {
            if (!value || value.trim() === "") return true;
            // Allow URLs with or without protocol
            const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
            return urlPattern.test(value);
          }
        ),
      otherwise: () => Yup.string().optional(),
    }
  ),
});
export const validationSchemaViewVirtualCard = Yup.object({
  view_virtual_card_would_you_like_i2c_hosted_view_virtual_card: Yup.string()
    .optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  view_virtual_card_technology_specification_for_i2c_web_view_integration: Yup.array().when(
    "view_virtual_card_would_you_like_i2c_hosted_view_virtual_card",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  view_virtual_card_technology_specification_for_i2c_web_view_integration_other: Yup.string().when(
    "view_virtual_card_technology_specification_for_i2c_web_view_integration",
    {
      is: (technologies) => technologies && technologies.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  view_virtual_i2c_hosted_web_view_language: Yup.array().when(
    "view_virtual_card_would_you_like_i2c_hosted_view_virtual_card",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  view_virtual_i2c_hosted_web_view_language_other: Yup.string().when(
    "view_virtual_i2c_hosted_web_view_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});
 export const validationSchemaSDK = Yup.object({
  sdk_would_you_like_i2c_hosted_mobile_sdk_application: Yup.string()
    .optional()
    .oneOf(["yes", "no", "na"], "Invalid selection"),
  sdk_technology_specification_for_i2c_mobile_sdk_integration: Yup.array().when(
    "sdk_would_you_like_i2c_hosted_mobile_sdk_application",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  sdk_technology_specification_for_i2c_mobile_sdk_integration_other: Yup.string().when(
    "sdk_technology_specification_for_i2c_mobile_sdk_integration",
    {
      is: (technologies) => technologies && technologies.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  sdk_i2c_hosted_mobile_sdk_language: Yup.array().when(
    "sdk_would_you_like_i2c_hosted_mobile_sdk_application",
    {
      is: (value) => value === "yes",
      then: () => Yup.array().optional(),
      otherwise: () => Yup.array().optional(),
    }
  ),
  sdk_i2c_hosted_mobile_sdk_language_other: Yup.string().when(
    "sdk_i2c_hosted_mobile_sdk_language",
    {
      is: (languages) => languages && languages.includes("other"),
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});